export const POST_DISPATCH_PRODUCT_TITLE = 'In this delivery:';
export const PRE_DISPATCH_PRODUCT_TITLE = 'to be sent:';
export const ESTIMATED_DELIVERY_SECTION = {
  title: 'Estimated delivery',
  text: `When we send something to you, we’ll show you when we expect it to arrive.
   You can check progress when a delivery’s on the way`,
};
